// Reusable validation patterns and functions
export const validationPatterns = {
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: 'Please enter a valid email address',
  },
  phone: {
    pattern: /^\+?[\d\s\-()]{10,}$/,
    message: 'Please enter a valid phone number',
  },
  url: {
    pattern:
      /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
    message: 'Please enter a valid URL',
  },
  alphanumeric: {
    pattern: /^[a-zA-Z0-9]+$/,
    message: 'Only letters and numbers are allowed',
  },
}

// Validation helper function
export const validateField = (value, validationType) => {
  if (!validationType || !value) return {isValid: true, message: ''}

  const validation = validationPatterns[validationType]
  if (!validation) return {isValid: true, message: ''}

  // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
  const isValid = validation.pattern.test(value)
  return {
    isValid,
    message: isValid ? '' : validation.message,
  }
}

export const productEntitlementsFieldConfig = {
  // Configurations for entitlements

  // Configurations for products (custom fields)
  'custom-dfy-keap-addon': {
    type: 'number',
    min: 1,
    max: 1000,
    label: 'Please specify a number between 1 and 1000',
  },
  'keap-text-voice-addon': {
    type: 'select',
    label: 'Select Text & Voice Package',
    options: [
      {value: 'package1', label: 'Package 1'},
      {value: 'package2', label: 'Package 2'},
      {value: 'package3', label: 'Package 3'},
    ],
  },
  'keap-additional-contacts': {
    type: 'select',
    label: 'Select Text & Voice Package',
    options: [
      {value: 'package1', label: 'Package 1'},
      {value: 'package2', label: 'Package 2'},
      {value: 'package3', label: 'Package 3'},
    ],
  },
  'hourly-data-service-addon': {
    type: 'number',
    min: 1,
    max: 99,
    label: 'Please specify a number between 1 and 99',
  },
}

export const productOptionsFieldConfig = {
  'addon-5-keap-addcontacts-m2m': {
    type: 'select',
    label: 'Select Additional Contacts',
    options: [
      {label: 'Up To 1000 Contacts: $36', value: '1000-36'},
      {label: 'Up To 2500 Contacts: $84', value: '2500-84'},
      {label: 'Up To 5000 Contacts: $150', value: '5000-150'},
      {label: 'Up To 10,000 Contacts: $240', value: '10000-240'},
      {label: 'Up To 15,000 Contacts: $330', value: '15000-330'},
      {label: 'Up To 25,000 Contacts: $420', value: '25000-420'},
      {label: 'Up To 50,000 Contacts: $480', value: '50000-480'},
      {label: 'Up To 75,000 Contacts: $600', value: '75000-600'},
      {label: 'Up To 100,000 Contacts: $720', value: '100000-720'},
      {label: 'Up To 200,000 Contacts: $1200', value: '200000-1200'},
      {label: 'Up To 500,000 Contacts: $1980', value: '500000-1980'},
      {label: 'Up To 750,000 Contacts: $2940', value: '750000-2940'},
      {label: 'Up To 1,000,000 Contacts: $3720', value: '1000000-3720'},
      {label: 'Up To 2,000,000 Contacts: $5940', value: '2000000-5940'},
      {label: 'Up To 3,000,000 Contacts: $7200', value: '3000000-7200'},
      {label: 'Up To 4,000,000 Contacts: $8460', value: '4000000-8460'},
      {label: 'Over 4,000,000 Contacts: $10140', value: '5000000-10140'},
    ],
  },
  'addon-5-keap-textvoice-m2m': {
    type: 'select',
    label: 'Select Text & Voice Tier',
    options: [
      {label: 'Tier 1: $14', value: '1-14'},
      {label: 'Tier 2: $24', value: '2-24'},
      {label: 'Tier 3: $39', value: '3-39'},
      {label: 'Tier 4: $79', value: '4-79'},
      {label: 'Tier 5: $139', value: '5-139'},
      {label: 'Tier 6: $279', value: '6-279'},
    ],
  },
  'addon-5-keap-custdfy-ot': {
    type: 'number',
    min: 1,
    max: 1000,
    label: 'Please specify a number between 1 and 1000',
  },
  'addon-5-keap-addusers-m2m': {
    type: 'number',
    min: 1,
    max: 99,
    label: 'Please specify a number between 1 and 99',
  },
  'addon-5-keap-hourlydatasvc': {
    type: 'number',
    min: 1,
    max: 99,
    label: 'Please specify a number between 1 and 99',
  },
}

export const uiGroupProductFieldConfig = {
  'mc_plus-5-thryv-m2m': {
    customFieldKey: 'domain',
    label: 'Enter domain to continue to purchase',
    placeholder: 'Enter your website domain',
    name: 'domain',
    validation: 'url',
    required: true,
  },
}
